import styled from 'styled-components';
import { Spacing } from 'web-common/src/shared/styles';
import { FontSize } from 'web-common/src/shared/styles/font';

export const ContentContainer = styled.div<{ fontSize: FontSize }>`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.HALF};
  font-size: ${({ fontSize }) => fontSize};
`;
